<template>
  <div class="mmm-uploader">
    <div class="uploader-container">
      <upload :country="Language.country"></upload>
    </div>

  </div>
</template>

<script>
  import * as types from "@/store/mutation-types";
  import Upload from "@/views/Upload";
  import {Language} from "@/i18n";

export default {
  name: 'App',
  components: {
    Upload
  },
  methods: {
    increment() {
      this.$store.dispatch(types.INCREMENT);
    },
    decrement() {
      this.$store.dispatch(types.DECREMENT);
    },
    reset() {
      this.$store.dispatch(types.RESET);
    },

  },
  computed: {
    Language() {
      return Language
    },
    count() {
      return this.$store.getters.count;
    }
  }
}
</script>

<style src="./assets/uploader.css"></style>
